import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const NewCodeAlert = ({
  keyWord,
  hideAlert,
  obfuscatedInfo
}) => {
  if (keyWord) {
    return /*#__PURE__*/_jsx(UIAlert, {
      type: "success",
      closeable: true,
      onClose: hideAlert,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `reAuth.alert.${keyWord}`,
        options: {
          obfuscatedInfo
        }
      })
    });
  } else {
    return /*#__PURE__*/_jsx("div", {});
  }
};
export default NewCodeAlert;